import React, { Suspense, useState, useRef, useEffect } from 'react'
import '../Registration/Registration.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import OtpInput from 'react-otp-input'
import {
  useHistory,
  Redirect
} from 'react-router-dom'
import { Button, } from 'reactstrap'
import Loading from '../../components/Loading'
import Header from '../../DefaultLayout/Header'
import Footer from '../../DefaultLayout/Footer'
import { checkRequiredValidationWithOTPMinMax } from '../../Helpers/Validation'
import { useDispatch, useSelector, connect } from 'react-redux'
import { userRegisterOtp } from '../../actions/authActions'
import ToastifyContainer from '../../components/Toastify/ToastifyContainer'
import { toast } from 'react-toastify'
import firebase from '../../Helpers/firebase'
import DashboardNavbar from '../../DefaultLayout/DashboardNavbar'
import { 
  CircularProgress,
} from "@mui/material"; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare } from '@fortawesome/free-regular-svg-icons';


const New_registration_otp_verification = (props) => {
  const { frontLabelsName } = props.label
  const{auth}=props

   const { isAuthenticated,  } = auth;
  
  const [otp, setOtp] = useState(0)
  const dispatch = useDispatch()
  const reCaptchRef = useRef()
  const history = useHistory()

  const [error_OTP, setErrorOTP] = useState('')
  const [seconds, setSeconds] = useState(30)
  const [resendCode, setResendCode] = useState(false)
  const [loading, setLoading] = useState(false)

  const saveOtp = useSelector((state) => state.saveOtp)
  const { userData } = saveOtp

  useEffect(() => {
 
    window.onbeforeunload = function (e) {
      return true
    }

    if (!userData?.userToken) {
      history.push('/access-by-otp')
      window.location.reload()
    }

    return () => {
      window.onbeforeunload = null
    }
  }, [])

  useEffect(() => {
    if (window.performance) {
      if (window.performance.navigation.type == 1) {
        var confirm = window.confirm(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == 'lbl_redirect_to_login')
                .length > 0
              ? frontLabelsName.filter((e) => e.key == 'lbl_redirect_to_login')[0][
                  'value'
                ] || 'lbl_redirect_to_login'
              : 'lbl_redirect_to_login'
            : 'lbl_redirect_to_login'
        )
        if (confirm) {
          history.push('/login')
        } else {
        }
      }
    }
  }, [])

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1)
      }
    }, 1000)

    return () => {
      clearInterval(interval)
    }
  }, [seconds])

  const handleChange = (data) => {
    setOtp(data)
  }

  const handleVerify = (e) => {
    e.preventDefault()
    let errOtp = null
    let validationFlag = true
    errOtp = checkRequiredValidationWithOTPMinMax(otp, 'lbl_OTP', 6)
    if (errOtp) {
      validationFlag = false
      setErrorOTP(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == errOtp).length > 0
            ? frontLabelsName.filter((e) => e.key == errOtp)[0]['value'] || errOtp
            : errOtp
          : errOtp
      )
    } else {
      validationFlag = true
      setErrorOTP('')
    }
    if (validationFlag) {
      setLoading(true)

      const userObj = {
        mobile_number: userData.mobileNumber,
        token: userData.userToken,
        countryCode: userData.countryCode,
        isSubscribing:false
      }
      window.confirmationResult
        .confirm(otp)
        .then((result) => {
          props.userRegisterOtp(userObj).then((res) => {
            dispatch({ type: 'REGISTER_OTP', payload: res.data })
            setErrorOTP('')
            setLoading(false)
     
            if(res?.data?.user?.isRegistrationCompleted  ){
              history.push('/dashboard')
               localStorage.removeItem("isSubscribing")
              toast.success(
                frontLabelsName
                  ? frontLabelsName.filter((e) => e.key == res.data.message).length >
                    0
                    ? frontLabelsName.filter((e) => e.key == res.data.message)[0][
                        'value'
                      ] || res.data.message
                    : res.data.message
                  : res.data.message
              )
            }else if (localStorage.getItem("isSubscribing") !== null) {
              
              dispatch({
                type:"SET_STEP",
                payload:{step:0,status:true}
             });
             localStorage.setItem("currentStepIndex", 0)
              history.push('/terms-and-condition')

            }else{
              if(res?.data?.user?.isSubscribing){
                dispatch({
                  type: "SET_IS_SUBSCRIBING",
                  payload: { isSubscribing: true },
                });
              localStorage.setItem("isSubscribing",true)
  
             
              }else{
  
                dispatch({
                  type: "SET_IS_SUBSCRIBING",
                  payload: { isSubscribing: false },
                });
              localStorage.setItem("isSubscribing",false)
        
             
              }
              dispatch({
                type:"SET_STEP",
                payload:{step:0,status:true}
             });
             localStorage.setItem("currentStepIndex", 0)
              history.push('/terms-and-condition')
            }
           
          
          })
        })
        .catch((err) => {
          setLoading(false)
      
          toast.error(
            frontLabelsName
              ? frontLabelsName.filter((e) => e.key == err.message).length > 0
                ? frontLabelsName.filter((e) => e.key == err.message)[0]['value'] ||
                  err.message
                : err.message
              : err.message
          )
        })
    }
  }

  function maskNumber(number) {
    let str = number.toString();
    let masked = '*'.repeat(str.length - 2) + str.slice(-2);
    return masked;
}

  

  const resendConfigCaptcha = (e) => {
  
    window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
      'resend-button',
      {
        size: 'normal',
        callback: (response) => {
          onSendOTP('', true)
        },
        'expired-callback': () => {
          console.log('Resend Captcha Expired. Re-rendering.');
          resendConfigCaptcha();
        }
      }
    )
    window.recaptchaVerifier.render().then(function (widgetId) {
      window.recaptchaWidgetId = widgetId
    })
  }

  const onSendOTP = (e, resend) => {
    if (resend) {
      setLoading(false)
      resendConfigCaptcha()

      const appVerifier = window.recaptchaVerifier

      let newNumber = userData?.countryCode + userData?.mobileNumber

      firebase
        .auth()
        .signInWithPhoneNumber(newNumber, appVerifier)
        .then((confirmationResult) => {
          dispatch({ type: 'SAVE_OTP', payload: userData })
          toast.success(
            frontLabelsName
              ? frontLabelsName.filter((e) => e.key == 'lbl_otp_has_been_sent')
                  .length > 0
                ? frontLabelsName.filter((e) => e.key == 'lbl_otp_has_been_sent')[0][
                    'value'
                  ] || 'lbl_otp_has_been_sent'
                : 'lbl_otp_has_been_sent'
              : 'lbl_otp_has_been_sent'
          )
          window.confirmationResult = confirmationResult
          setSeconds(30)
        })
        .catch((err) => {
          setLoading(false)

          if (
            err.message ==
            'The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].'
          ) {
            toast.error(
              frontLabelsName
                ? frontLabelsName.filter(
                    (e) =>
                      e.key ==
                      'lbl_the_format_of_the_phone_number_provided_is_incorrect'
                  ).length > 0
                  ? frontLabelsName.filter(
                      (e) =>
                        e.key ==
                        'lbl_the_format_of_the_phone_number_provided_is_incorrect'
                    )[0]['value'] ||
                    'lbl_the_format_of_the_phone_number_provided_is_incorrect'
                  : 'lbl_the_format_of_the_phone_number_provided_is_incorrect'
                : 'lbl_the_format_of_the_phone_number_provided_is_incorrect'
            )
          } else {
            toast.error(
              frontLabelsName
                ? frontLabelsName.filter((e) => e.key == err.message).length > 0
                  ? frontLabelsName.filter((e) => e.key == err.message)[0][
                      'value'
                    ] || err.message
                  : err.message
                : err.message
            )
          }
        })
    }
  }
  const handleRedirection=()=>{
    history.push('/access-by-otp')

  }
  if (isAuthenticated ) {
    return <Redirect to="/dashboard" />;
  }
  return (
    <React.Fragment>
      <Suspense fallback={<Loading />}>
        <Header />
     
        <DashboardNavbar/>
      </Suspense>
      <div className="container mb-5 pt-5">
        <div className="row">
          <ToastifyContainer />

          <div className="main-otp-box">
            <div className="otp-box-rg-new pb-5">
              <form>
                <div className="img-mob text-center">
                  <img src="assets/ver2.svg" alt="mobile" />
                  <h2>
                    <strong>
                      {frontLabelsName
                        ? frontLabelsName.filter(
                            (e) => e.key == 'lbl_otp_verification'
                          ).length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == 'lbl_otp_verification'
                            )[0]['value'] || 'lbl_otp_verification'
                          : 'lbl_otp_verification'
                        : 'lbl_otp_verification'}
                    </strong>
                  </h2>
                  <p className="color-set-otp">
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == 'lbl_enter_otp')
                          .length > 0
                        ? frontLabelsName.filter((e) => e.key == 'lbl_enter_otp')[0][
                            'value'
                          ] || 'lbl_enter_otp'
                        : 'lbl_enter_otp'
                      : 'lbl_enter_otp'}
                    <strong className='pe-2'> {maskNumber(userData.mobileNumber)}</strong>
                    <FontAwesomeIcon icon={faPenToSquare} style={{ color: '#f5d792 ' ,fontSize:"20px",cursor:"pointer"}} onClick={handleRedirection} />
            
                  </p>

                  <div className="four-text-box d-flex">
                    <OtpInput
                      value={otp}
                      onChange={handleChange}
                      OTPLength={6}
                      numInputs={6}
                      type="number"
                      inputStyle={{ width: '2em', margin: '5px' }}
                      autofocus
                      disabled={false}
                      secure
                      isInputNum
                    />
                  </div>
                  {error_OTP && (
                    <span style={{ color: 'red' }}>{error_OTP}</span>
                  )}
                  <p className="color-set-otp">
                    {seconds > 0 ? (
                      <p> {frontLabelsName
                        ? frontLabelsName.filter(
                            (e) => e.key == 'lbl_you_can_resend_otp_after'
                          ).length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == 'lbl_you_can_resend_otp_after'
                            )[0]['value'] || 'lbl_you_can_resend_otp_after'
                          : 'lbl_you_can_resend_otp_after'
                        : 'lbl_you_can_resend_otp_after'}&nbsp;
                          <strong
                        className="text-dark"
                       
                    
                      >
                         {seconds < 10 ? `0${seconds}` : seconds} {frontLabelsName
                          ? frontLabelsName.filter(
                              (e) => e.key == 'lbl_seconds'
                            ).length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == 'lbl_seconds'
                              )[0]['value'] || 'lbl_seconds'
                            : 'lbl_seconds'
                          : 'lbl_seconds'}
                      </strong>
                        </p>
                    ):
                    <p>
                      {frontLabelsName
                        ? frontLabelsName.filter(
                            (e) => e.key == 'lbl_dont_receive_otp'
                          ).length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == 'lbl_dont_receive_otp'
                            )[0]['value'] || 'lbl_dont_receive_otp'
                          : 'lbl_dont_receive_otp'
                        : 'lbl_dont_receive_otp'}
                      <strong
                        className="text-dark"
                        style={{
                          cursor: seconds == 0 ? 'pointer' : 'not-allowed',
                        }}
                        onClick={(e) => {
                          if (seconds == 0) {
                            setOtp('')
                            setResendCode(true)
                            onSendOTP(e, true)
                          }
                        }}
                      >
                        {' '}
                        {frontLabelsName
                          ? frontLabelsName.filter((e) => e.key == 'lbl_resend_otp')
                              .length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == 'lbl_resend_otp'
                              )[0]['value'] || 'lbl_resend_otp'
                            : 'lbl_resend_otp'
                          : 'lbl_resend_otp'}
                      </strong>
                    </p>}
                  </p>
                  <div ref={reCaptchRef}>
                    <div id="resend-button" hidden={!resendCode}></div>
                  </div>
                  <div className="button-set pt-3">
                
                    <Button
                      onClick={handleVerify}
                      disabled={loading}
                      type="submit"
                    >
                      {loading ? (
                                                                    <CircularProgress
                                                                      size={24}
                                                                      sx={{
                                                                        ":hover": { color: "#000" },
                                            
                                                                        color: "#000",
                                                                       
                                                                      }}
                                                                    />
                                                                  ) :frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == 'lbl_verify')
                            .length > 0
                          ? frontLabelsName.filter((e) => e.key == 'lbl_verify')[0][
                              'value'
                            ] || 'lbl_verify'
                          : 'lbl_verify'
                        : 'lbl_verify'}
                    </Button>
              
                  </div>
                </div>
              </form>
              
            </div>
          </div>
        </div>
      </div>
      <Suspense fallback={<Loading />}>
        <Footer />
      </Suspense>
    </React.Fragment>
  )
}
const mapStateToProps = (state) => ({
  label: state.language,
  auth: state.auth,
})

export default connect(mapStateToProps, {
  userRegisterOtp,
})(New_registration_otp_verification)
